import {
  IonIcon,
  IonItem,
  IonItemGroup,
  IonLabel,
  IonReorder,
  IonReorderGroup,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import {
  removeCircleOutline as removeIcon,
  addCircleOutline as addIcon,
} from "ionicons/icons";

import { ICategory } from "../../state";
import CategoryLabel from "../../atoms/CategoryLabel";
import NewCategoryForm from "../../molecules/NewCategoryForm";
import ModalConfirm from "../../molecules/ModalConfirm";
import ToolTip from "../../atoms/ToolTip";

import styles from "./EditCategories.module.scss";

export interface EditCategoriesProps {
  categories: ICategory[];
  calling: boolean;
  values: { [key: string]: any };
  update: (args: { [key: string]: any }) => void;
  updateCategory(
    category_id: number,
    category: { name: string; color: string },
  ): void;
  createCategory(category: { name: string; color: string }): void;
  destroyCategory(category_id: number): void;
  reorderCategories(categories: ICategory[]): void;
}

const EditCategories = (props: EditCategoriesProps) => {
  const isTeacherCategory = (category: ICategory) => category.teacher_id;
  const teacherCategories = props.categories.filter(isTeacherCategory);
  const [studentCategories, setStudentCategories] = useState<ICategory[]>([
    ...props.categories.filter(c => !c.teacher_id),
  ]);

  function doReorder(event: CustomEvent) {
    const reordered = event.detail.complete([...studentCategories]);
    setStudentCategories(reordered);
    props.reorderCategories(reordered);
    props.update({ categories: reordered });
  }

  useEffect(() => {
    setStudentCategories([...props.categories.filter(c => !c.teacher_id)]);
  }, [props.categories]);

  return (
    <>
      <ModalConfirm
        isOpen={props.values.showCategoryDeleteForm}
        message={
          <>
            ストックから活かし先を外し、
            <br />「{props.values.category_name}」を削除しますか？
            <br />
            この操作は取り消しができません。
          </>
        }
        buttons={[
          {
            title: "キャンセル",
            action: () => props.update({ showCategoryDeleteForm: false }),
            type: "None",
          },
          {
            title: "削除する",
            action: () => {
              props.destroyCategory(props.values.category_id);
              props.update({ showCategoryDeleteForm: false, category_id: 0 });
            },
            type: "Danger",
          },
        ]}
      />
      <IonItem className={styles.categoryItem}>
        <IonLabel color="light">活かし先を新規作成</IonLabel>
        <IonIcon
          className={styles.addIcon}
          slot="end"
          icon={addIcon}
          onClick={() => {
            props.update({
              showNewCategoryForm: true,
              editable: false,
            });
          }}
        />
      </IonItem>
      <NewCategoryForm
        calling={props.calling}
        values={props.values}
        visible={props.values.showNewCategoryForm}
        update={props.update}
        createCategory={props.createCategory}
        updateCategory={props.updateCategory}
      />
      <IonItemGroup>
        {teacherCategories &&
          teacherCategories.map(category => (
            <IonItem key={category.id} className={styles.categories}>
              {props.values.editable && category.teacher_id && (
                <ToolTip
                  content="先生が作成した活かし先なので削除できません"
                  placement="right"
                >
                  <IonIcon
                    className={styles.subjectLinkedRemoveButton}
                    icon={removeIcon}
                    slot="start"
                  />
                </ToolTip>
              )}
              <CategoryLabel
                editable={props.values.editable}
                label={category.name}
                color={category.color}
                count={category.realization_count}
                isTeacherCategory
              />
            </IonItem>
          ))}
      </IonItemGroup>
      <IonReorderGroup
        disabled={!props.values.editable || props.calling}
        onIonItemReorder={doReorder}
      >
        {studentCategories &&
          studentCategories.map(category => (
            <IonItem key={category.id} className={styles.categories}>
              {props.values.editable && (
                <IonIcon
                  className={styles.removeIcon}
                  icon={removeIcon}
                  slot="start"
                  onClick={() => {
                    if (props.calling) return;
                    props.update({
                      showCategoryDeleteForm: true,
                      category_id: category.id ? category.id : 0,
                      category_name: category.name,
                    });
                  }}
                />
              )}
              <CategoryLabel
                selectable
                editable={props.values.editable}
                label={category.name}
                color={category.color}
                count={category.realization_count}
                onClick={() => {
                  if (props.values.editable) {
                    props.update({
                      showNewCategoryForm: true,
                      category_id: category.id ? category.id : 0,
                      editCategory: true,
                      name: category.name,
                      color: category.color,
                    });
                  }
                }}
              />
              <IonReorder slot="end" className={styles.reorderIcon} />
            </IonItem>
          ))}
      </IonReorderGroup>
    </>
  );
};

export default EditCategories;
